import { ReactComponent as IconDownload } from "../../assets/svg/download.svg";
import { luckyorangeTrackEven } from "../../services/lucky-orange/luckyorange-events";

// style
import './anchor-button.css'

export const AnchorDownloadButton = ({ link, title, disabled }) => {
  const downloadHandler = () => {
      luckyorangeTrackEven(`Results: download ${title}`);
    };
  return (
    <a href={link ? link : null} download className={`download-anchor-btn ${disabled ? 'disabled' : ''}`} onClick={downloadHandler}>
      <IconDownload stroke={disabled ? '#d0d5dd' :"#343745"} width="14px" height="14px" />
      {title}
    </a>
  );
};
